import { useAppSelector } from '@app/hooks';
import { FeatureKeys, useFeatureFlag } from '@components/feature-flags';
import { selectIqtModeOn } from '@modules/user';
import { defineShowTbdLabel } from './helpers';

export function useTbdPrice(isTbd: boolean) {
    const isIqtModeTbdShown = useFeatureFlag(FeatureKeys.Mode.IqtModeTbdShown);
    const iqtModeOn = useAppSelector(selectIqtModeOn);
    const { showPrice, showTbdLabel } = defineShowTbdLabel({
        iqtModeOn,
        isIqtModeTbdShown,
        isTbd,
    });

    return { showPrice, showTbdLabel };
}
